/**
 * Lib Module Browsers
 *
 * @param asJson
 * @returns {{screen: {width: Number, height: Number}, viewport: {width: (*|jQuery), height: (*|jQuery)}, date: {current}}}
 * @constructor
 */
Lib.Browser = function (asJson) {

    var date = new Date();

    var browserData = {
        screen: {
            width: screen.width,
            height: screen.height
        },
        viewport: {
            width: $(window).width(),
            height: $(window).height()
        },
        date: {
            current: date.toString()
        }
    };
    return (asJson) ? JSON.stringify(browserData) : browserData;

};
